import { jsxs, jsx } from 'react/jsx-runtime';
import { Flex, themedColor, font, Box } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES, Button } from '@lemonade-hq/nuis';
import { useContext } from 'react';
import styled, { css } from 'styled-components';
import { urlWithPreventRedirect } from '../../helpers/routes.esm.js';
import { CommonI18nContext } from '../../providers/I18nProvider.esm.js';
import { NavContext } from '../../providers/NavProvider.esm.js';
import { IceCreamRedSvg } from './IceCreamRedSvg.esm.js';
import { IceCreamSvg } from './IceCreamSvg.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      width: 70%;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 62px;\n  max-width: 407px;\n  height: auto;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n      border-bottom: 3px solid ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  min-height: 670px;\n  height: calc(100% - 400px);\n  text-align: center;\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  padding: 15px 45px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
var StyledSvg = styled.div(_templateObject1(), MEDIA_QUERIES.mobile(_templateObject()));
var ErrorContainer = styled(Flex)(_templateObject3(), function(props) {
    return props.hasBottomBorder && css(_templateObject2(), themedColor("primary"));
});
var ErrorHeader = styled.h1(_templateObject4(), font("alt", {
    fontSize: "4rem",
    lineHeight: 1.3
}), themedColor("night"));
var ErrorSubtitle = styled.p(_templateObject5(), font("main", {
    fontSize: "1.6rem",
    lineHeight: 1.3
}));
var Cta = styled(Button)(_templateObject6());
var ErrorPage = function(_param) {
    var _param_hasBottomBorder = _param.hasBottomBorder, hasBottomBorder = _param_hasBottomBorder === void 0 ? false : _param_hasBottomBorder, title = _param.title, subtitle = _param.subtitle, props = _object_without_properties(_param, [
        "hasBottomBorder",
        "title",
        "subtitle"
    ]);
    var _useContext = useContext(CommonI18nContext), t = _useContext.t, region = _useContext.region;
    var nav = useContext(NavContext).nav;
    var isDE = region === "DE";
    return /*#__PURE__*/ jsxs(ErrorContainer, _object_spread_props(_object_spread({
        alignItems: "center",
        flex: 1,
        flexDirection: "column",
        hasBottomBorder: hasBottomBorder,
        justifyContent: "center",
        pt: "48px"
    }, props), {
        children: [
            /*#__PURE__*/ jsx(Box, {
                maxWidth: "720px",
                mb: "16px",
                children: /*#__PURE__*/ jsx(ErrorHeader, {
                    children: title !== null && title !== void 0 ? title : t("error_page.title")
                })
            }),
            /*#__PURE__*/ jsx(Box, {
                pb: "30px",
                children: /*#__PURE__*/ jsx(ErrorSubtitle, {
                    children: subtitle !== null && subtitle !== void 0 ? subtitle : t("error_page.subtitle")
                })
            }),
            isDE ? /*#__PURE__*/ jsx(StyledSvg, {
                as: IceCreamRedSvg
            }) : /*#__PURE__*/ jsx(StyledSvg, {
                as: IceCreamSvg
            }),
            /*#__PURE__*/ jsx(Cta, {
                as: "a",
                flavor: "primary",
                glowing: true,
                href: urlWithPreventRedirect(nav.home),
                children: t("error_page.action")
            })
        ]
    }));
};

export { ErrorPage };
